const mutations = {
  setZoneGroup(state, data) {
    state.zonegroupEdit = data
  },
  setDeleteZoneGroup(state, data) {
    state.zonegroupDelete = data
  }
}

export default mutations